import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { withNamespaces } from "react-i18next";

const MyDialog = ({
  t,
  showModal,
  handleClose,
  title,
  message,
  handleAgree,
  noLabel,
  yesLabel,
}) => {
  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t(noLabel)}
        </Button>
        <Button onClick={handleAgree} color="primary" autoFocus>
          {t(yesLabel)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MyDialog.defaultProps = {
  showModal: false,
  noLabel: "No",
  yesLabel: "Yes",
};

export default withNamespaces()(MyDialog);
